import { render, staticRenderFns } from "./RoleCompanyAdd.vue?vue&type=template&id=46ad9fe2&scoped=true"
import script from "./RoleCompanyAdd.vue?vue&type=script&lang=js"
export * from "./RoleCompanyAdd.vue?vue&type=script&lang=js"
import style0 from "./RoleCompanyAdd.vue?vue&type=style&index=0&id=46ad9fe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ad9fe2",
  null
  
)

export default component.exports